import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=965d9caa"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"
import style0 from "./Slider.vue?vue&type=style&index=0&id=965d9caa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports